import { useState, useEffect } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'

import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getEmployee } from '..'
import { toast } from '@sales-center/components'

export const useGetEmployeeOnMount = (employeeId?: string) => {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getEmployee(employeeId!))

        if (mounted) {
          if (getEmployee.fulfilled.match(result)) {
            unwrapResult(result)
            setStatus('success')
          } else {
            // rejected
            setStatus('fail')
            toast.error('Error loading employee details.')
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    if (employeeId) execute()

    return () => {
      mounted = false
    }
  }, [dispatch, employeeId])

  return status
}
